/**
 * Auto-formats [data-phone-format] inputs as ###-###-#### while typing or pasting.
 */
(function () {
  if (window.__relicPhoneFormatInit) return;
  window.__relicPhoneFormatInit = true;

  function formatPhoneInput(input) {
    const digits = input.value.replace(/\D/g, '').slice(0, 10);
    let formatted = digits.slice(0, 3);

    if (digits.length > 3) {
      formatted += '-' + digits.slice(3, 6);
    }

    if (digits.length > 6) {
      formatted += '-' + digits.slice(6, 10);
    }

    if (input.value !== formatted) {
      input.value = formatted;
    }
  }

  function maybeFormatPhoneInput(event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || !input.matches('[data-phone-format]')) {
      return;
    }

    formatPhoneInput(input);
  }

  document.addEventListener('input', maybeFormatPhoneInput);

  document.addEventListener('paste', function (event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || !input.matches('[data-phone-format]')) {
      return;
    }

    requestAnimationFrame(function () {
      formatPhoneInput(input);
    });
  });

  document.addEventListener(
    'blur',
    function (event) {
      maybeFormatPhoneInput(event);
    },
    true
  );
})();
